export class ErrorResponse {
    constructor(public message: string, public status = 0) {
    }
}

export class CommonErrorResponse {
    constructor(public message: string, public ok = 'OK') {
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/error.modal/error.response.ts